React = require 'react'
{ Component, PropTypes } = React
{ Button, Input, Alert, Link } = require 'react-bootstrap'
{ reduxForm } = require 'redux-form'
{ Link } = require 'react-router'
formValidations = require '../../../a2i/js/lib/formValidations'
background = require '../../../shared/js/lib/background'
require '../../styles/Login'

class Login extends Component
	@propTypes:
		errorMessage: PropTypes.string
		isAuthenticated: PropTypes.bool.isRequired
		loginPrompt: PropTypes.string
		onLogin: PropTypes.func.isRequired
		redirectAfterLogin: PropTypes.func.isRequired
		localStorageWorks: PropTypes.bool

		fields: PropTypes.object.isRequired
		handleSubmit: PropTypes.func.isRequired
		resetForm: PropTypes.func.isRequired
		submitting: PropTypes.bool.isRequired

	@contextTypes:
		router: PropTypes.object.isRequired

	getBackgroundImageUrl: ->
		return @backgroundUrl if @backgroundUrl
		url = background.getImageUrl()
		@backgroundUrl = 'url(' + url + ')'
		@backgroundUrl

	onSubmit: (values) =>
		credentials = { username: values.username, password: values.password }
		@props.onLogin credentials
		.then (payload) =>
			if payload?.success
				@props.resetForm()
				@props.redirectAfterLogin @context.router, @props.location.query.redirect
		, (reason) =>

	getUsernameFeedback: (value) ->
		return {} if @props.submitting
		if @props.errorMessage
			return {
				hasFeedback: true
				bsStyle: 'error'
				help: @props.errorMessage
			}
		else
			@getBsFeedback(value)

	getPasswordFeedback: (value) ->
		return {} if @props.submitting
		if @props.errorMessage
			return {
				hasFeedback: true
				bsStyle: 'error'
				help: ''
			}
		else
			@getBsFeedback(value)

	getBsFeedback: (value) ->
		feedback = {}
		if value.touched
			feedback =
				hasFeedback: true,
				bsStyle: if value.valid then 'success' else 'error'
				help: value.touched and if value.error then value.error else ''
		feedback

	render: =>
		{ fields: { username, password }, localStorageWorks } = @props
		if !localStorageWorks
			return React.createElement("div", null, "Your browser does not support localStorage, which is required by this application. If you are using Safari, ensure you are not in a private browser tab.")
		loginPrompt = null
		if @props.loginPrompt
			loginPrompt = React.createElement(Alert, {"className": "login-prompt", "bsStyle": "danger"},
				React.createElement("p", null, (@props.loginPrompt))
			)
		okButtonCssClass = 'glyphicon glyphicon-' + if @props.submitting then 'refresh glyphicon-spin' else 'ok'
		React.createElement("div", { \
			"className": "login-container fill-display",  \
			"style": ({ backgroundImage: @getBackgroundImageUrl() })
		},
			(
				if @props.isAuthenticated
					React.createElement("div", null, """
\t\t\t\t\t\tYou are already logged in. Use the navigation to visit another page or """, React.createElement(Link, {"to": '/'}, "go to the home page"), """.
""")
				else
					React.createElement("div", {"className": "container"},
						React.createElement("div", {"className": "row"},
							React.createElement("div", {"className": "login-module"},
								React.createElement("form", {"onSubmit": (@props.handleSubmit(@onSubmit))},
									React.createElement("h1", null, "Welcome to OLOS!"),
									React.createElement("p", null, "Your portal to supporting effective instruction through observation"),
									(loginPrompt),
									React.createElement("div", {"className": "login-controls"},
										React.createElement(Input, React.__spread({"type": "text", "autoCapitalize": "none", "autoFocus": (true), "label": "Username"}, username,  @getUsernameFeedback(username), {"onBlur": ( -> null )})),
										React.createElement(Input, React.__spread({"type": "password", "label": "Password"}, password,  @getPasswordFeedback(password), {"onBlur": ( -> null )}))
									),
									React.createElement(Button, {"type": "submit", "bsStyle": "success", "className": "btn-lg", "disabled": ( @props.submitting )},
										React.createElement("i", {"className": (okButtonCssClass)}), """ Log in
"""),
									React.createElement("div", null,
										React.createElement("a", {"className": "forgot-password", "href": "/reset_password"}, "Forgot your password?")
									)
								)
							)
						)
					)
			)
		)

config =
	form: 'login'
	fields: ['username', 'password']
	validate: formValidations.createValidator
		username: formValidations.required
		password: [formValidations.required]#, formValidations.minLength(4)]

module.exports = reduxForm(config)(Login)
module.exports.undecorated = Login



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/Login.cjsx